




import { Component, Vue, Prop } from 'vue-property-decorator';
import { EIssueStatus } from '@/lib/enums';

@Component
export default class IssueStatus extends Vue {
  @Prop() private status!: EIssueStatus;

  private get statusClass(): string {
    switch (this.status) {
      case EIssueStatus.ToDo:
        return 'label_todo';
      case EIssueStatus.InProgress:
        return 'label_inwork';
      case EIssueStatus.InReview:
      case EIssueStatus.InVerification:
        return 'label_inreview';
      default:
        return 'label_done';
    }
  }
}
